<section class="section about" id='about'>
    <div class="container">
        <div class="section-box">
             <div class="about-title" data-aos="fade-up">
                <h3 class="section-title">
                    <span class='n-section-title'>01.</span> Acerca de mi
                </h3>
             </div>
            <div data-aos="fade-up" data-aos-duration="1000" class="row">
                <div class="col-12 col-md-6 mb-4 mb-md-0">
                    <p>{{aboutDesc?.description}}</p>
                    <button class="boton_editar" (click)="goToEditAbout()">
                    <img class="boton_editar" src="/assets/images/boton_editar_3.png"/>
                    </button>
                    <div class="about-description">
                        <div class="skills-list">
                            
                            <div id="habilidad" class="col-6 col-md-6" *ngFor="let habilidad of AboutHabilidades"><span class="underline">
                        {{habilidad?.habilidad}}</span>
                      </div>
                      <button class="boton_editar" (click)="goToHabilidad()">
                        <img class="boton_editar" src="/assets/images/boton_editar_3.png"/>
                        </button>
                    </div>
                </div>
                </div>
                    <div class="col-12 col-md-6 mt-4 mt-md-0 text-center" data-aos="fade-up" data-aos-duration="1000">
                    <div class="about-img-container">
                        <img class="rounded" width="300" height="300" src="{{aboutDesc?.img_url}}" alt="Portfolio - apellido - nombre">
                    </div>
                    <button class="boton_editarfoto" (click)="goToEditAbout()">
                        <img class="boton_editar" src="/assets/images/boton_editar_3.png"/>
                        </button>
                </div>
            </div>
        </div>
    </div>
</section>
